import { send } from "../../send";

/**
 * send(1.method, 2.url, 3.data, 4.expend) 1.请求类型 2.请求地址 3.请求参数 4.拓展(如统一的uuid)
 * 事件中心 巡检模块
 */

export const Info = {
    /**
     * 投诉模块
     */
    // 查询投诉列表
    getConstraintList(parmas, expend) {
        return send("GET", "/api/company/environmental/complaintEvent/find", parmas, expend);
    },
    // 添加投诉
    postAddConstraint(parmas, expend) {
        return send("POST", "/api/company/environmental/complaintEvent/create", parmas, expend);
    },
    // 修改投诉
    postEditConstraint(parmas, expend) {
        return send("POST", "/api/company/environmental/complaintEvent/update", parmas, expend);
    },
    // 删除投诉
    postDelConstraint(parmas, expend) {
        return send("POST", "/api/company/environmental/complaintEvent/delete", parmas, expend);
    },
    /**
     * 评价模块
     */
    // 查询奖惩列表
    getEvaluateList(parmas, expend) {
        return send("GET", "/api/company/environmental/find", parmas, expend);
    },
    // 添加评价
    postAddEvaluate(parmas, expend) {
        return send("POST", "/api/company/environmental/create", parmas, expend);
    },
    // 修改评价
    postEditEvaluate(parmas, expend) {
        return send("POST", "/api/company/environmental/update", parmas, expend);
    },
    // 删除评价
    postDelEvaluate(parmas, expend) {
        return send("POST", "/api/company/environmental/delete", parmas, expend);
    },
    /**
     * 奖惩模块
     */
    // 查询奖惩列表
    getRewardList(parmas, expend) {
        return send("GET", "/api/company/environmental/processResult/find", parmas, expend);
    },
    // 添加奖惩
    postAddReward(parmas, expend) {
        return send("POST", "/api/company/environmental/processResult/create", parmas, expend);
    },
    // 修改奖惩
    postEditReward(parmas, expend) {
        return send("POST", "/api/company/environmental/processResult/update", parmas, expend);
    },
    // 删除奖惩
    postDelReward(parmas, expend) {
        return send("POST", "/api/company/environmental/processResult/delete", parmas, expend);
    },
    /**
     * 其他模块
     */
    // 查询其他列表
    getOtherList(parmas, expend) {
        return send("GET", "/api/company/environmental/other/find", parmas, expend);
    },
    // 添加其他
    postAddOther(parmas, expend) {
        return send("POST", "/api/company/environmental/other/create", parmas, expend);
    },
    // 修改其他
    postEditOther(parmas, expend) {
        return send("POST", "/api/company/environmental/other/update", parmas, expend);
    },
    // 删除其他
    postDelOther(parmas, expend) {
        return send("POST", "/api/company/environmental/other/delete", parmas, expend);
    },
    /**
     * 批复模块
     */
    getReplyList(parmas, expend) {
        return send("GET", "/api/company/environmental/evaluationApproval/find", parmas, expend);
    },
    // 添加批复
    postAddReply(parmas, expend) {
        return send("POST", "/api/company/environmental/evaluationApproval/create", parmas, expend);
    },
    // 修改批复
    postEditReply(parmas, expend) {
        return send("POST", "/api/company/environmental/evaluationApproval/update", parmas, expend);
    },
     // 删除批复
    postDelReply(parmas, expend) {
        return send("POST", "/api/company/environmental/evaluationApproval/delete", parmas, expend);
    },
   /**
     * 环保知识库
     */
    // 查询列表
    getKnowledgeBaseList(parmas, expend) {
        return send("GET", "/api/company/knowledge/base/find", parmas, expend);
    },
    // 添加
    postKnowledgeBaseAdd(parmas, expend) {
        return send("POST", "/api/company/knowledge/base/create", parmas, expend);
    },
    // 修改
    postKnowledgeBaseEdit(parmas, expend) {
        return send("POST", "/api/company/knowledge/base/modify", parmas, expend);
    },
    // 删除
    postKnowledgeBaseDel(parmas, expend) {
        return send("GET", "/api/company/knowledge/base/del/" + parmas.content.id, {}, expend);
    },
    /**
     * 环境应急信息
     */
    // 查询列表
    getContingencyInfoList(parmas, expend) {
        return send("GET", "/api/company/contingency/info/find", parmas, expend);
    },
    // 添加
    postContingencyInfoAdd(parmas, expend) {
        return send("POST", "/api/company/contingency/info/create", parmas, expend);
    },
    // 修改
    postContingencyInfoEdit(parmas, expend) {
        return send("POST", "/api/company/contingency/info/modify", parmas, expend);
    },
    // 删除
    postContingencyInfoDel(parmas, expend) {
        return send("GET", "/api/company/contingency/info/del/" + parmas.content.id, {}, expend);
    },
    /**
     * 环境应急物资
     */
    // 查询列表
    getContingencySuppliesList(parmas, expend) {
        return send("GET", "/api/company/contingency/supplies/find", parmas, expend);
    },
    // 添加
    postContingencySuppliesAdd(parmas, expend) {
        return send("POST", "/api/company/contingency/supplies/create", parmas, expend);
    },
    // 修改
    postContingencySuppliesEdit(parmas, expend) {
        return send("POST", "/api/company/contingency/supplies/modify", parmas, expend);
    },
    // 删除
    postContingencySuppliesDel(parmas, expend) {
        return send("GET", "/api/company/contingency/supplies/del/" + parmas.content.id, {}, expend);
    },
    /**
     * 环境应急预案
     */
    // 查询列表
    getEnvironmentalEmergencyPlanList(parmas, expend) {
        return send("GET", "/api/company/environmental/emergency/plan/find", parmas, expend);
    },
    // 添加
    postEnvironmentalEmergencyPlanAdd(parmas, expend) {
        return send("POST", "/api/company/environmental/emergency/plan/create", parmas, expend);
    },
    // 修改
    postEnvironmentalEmergencyPlanEdit(parmas, expend) {
        return send("POST", "/api/company/environmental/emergency/plan/modify", parmas, expend);
    },
    // 删除
    postEnvironmentalEmergencyPlanDel(parmas, expend) {
        return send("GET", "/api/company/environmental/emergency/plan/del/" + parmas.content.id, {}, expend);
    },
    /**
     * 问题反馈
     */
    // 查询列表
    getFeedbackList(parmas, expend) {
        return send("GET", "/api/company/feedback/find", parmas, expend);
    },
    // 添加
    postFeedbackAdd(parmas, expend) {
        return send("POST", "/api/company/feedback/create", parmas, expend);
    },
    // 修改
    postFeedbackEdit(parmas, expend) {
        return send("POST", "/api/company/feedback/modify", parmas, expend);
    },
    // 删除
    postFeedbackDel(parmas, expend) {
        return send("GET", "/api/company/feedback/del/" + parmas.content.id, {}, expend);
    },
}